'use client';
import * as React from 'react';
import { PriceBarQuantityContext } from './price-bar.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

/**
 * @subcomponent PriceBar
 */ const PriceBarQuantity = renderWithRef('PriceBarQuantity', null, (props, ref)=>{
    const classNames = new Set([
        'swan-button'
    ]);
    const [buttonId, setButtonId] = React.useState() || null;
    const [labelId, setLabelId] = React.useState() || null;
    return /*#__PURE__*/ React.createElement(PriceBarQuantityContext.Provider, {
        value: {
            buttonId,
            setButtonId,
            labelId,
            setLabelId
        }
    }, /*#__PURE__*/ React.createElement(RenderComp, {
        root: "button",
        forwardedRef: ref,
        classNames: classNames,
        props: props
    }, props.children));
});

export { PriceBarQuantity };
